import { Camera } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const CameraIcon = createLucideIcon(Camera);
